import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-3 mt-4" }
const _hoisted_2 = { class: "flight-pack-text text-grey-900" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "mx-2 text-grey-900"
}
const _hoisted_7 = { class: "d-flex align-items-center me-1 flex-column" }
const _hoisted_8 = {
  width: "20",
  height: "20",
  class: "icon me-1"
}
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = { class: "package-label" }
const _hoisted_11 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center prestation-discount-container f bg-primary-orange ms-1 ms-xl-3"
}
const _hoisted_13 = { class: "prestation-discount subcaption-strong text-primary-white px-2 py-1 text-nowrap" }

import { computed, onMounted } from "vue"
import { useStore } from "vuex"

// Computed
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"

// Config
import packageCompositionConfig from "@/config/packageCompositionConfig"
import { type PackageComponent } from "@/config/packageCompositionConfig"

// Logic
import { isCS } from "@/vue/planning/logic/cs"
import getPackageComposition from "@/vue/planning/logic/getPackageComposition"

// Utils 
import { hasChangedTransportType } from "@/utils/transportation"
import { airportCodeMap } from "@/config/airportCodeMap"
import flightPackCode from "@/config/flightPackCode"
import transportPackCode from "@/config/transportPackCode"


export default /*@__PURE__*/_defineComponent({
  __name: 'flightPackages',
  setup(__props) {

const store = useStore()

// Computed
const packCode = computed<string>(() => store.state.packCode)
const isLocaleNL = computed<boolean>(() => store.getters.isLocaleNL)
const isLocaleEN = computed<boolean>(() => store.getters.isLocaleEN)
const content = computed<Record<string, string>>(() => store.state.content)
const availablePackCodes = computed<{ codePackage: string }[]>(() => store.getters.availablePackCodes)
const maxPromosFromAvailablePackages = computed(() => store.getters.maxPromosFromAvailablePackages)

// Methods
const getPackageCompositionConfig = (packageCode: string) => {
	const composition = packageCompositionConfig[packageCode]?.components || []
	return composition
}

const getContentKey = (component: PackageComponent) => {
	// Use short version for Dutch and English locales
	let keyToUse = component.contentKey
	if ((isLocaleNL.value || isLocaleEN.value) && component.contentKeyShort) {
		keyToUse = component.contentKeyShort
	}
	return content.value[keyToUse]
}

const handlePackageChange = async (packObj: {
	codePackage: string
	packageId: string
}) => {
	// Check if the new package is a flight pack and select the first available origin
	const isFlightPackage = flightPackCode.includes(packObj.codePackage)
	const isTrainPackage = transportPackCode.includes(packObj.codePackage)
	if (isFlightPackage) {
		// Always select the first available origin when switching to a flight package tab
		store.dispatch("selectDefaultFlightOrigin", { overwrite: true, forceFlightPackCode: true })
	} else if (isTrainPackage) {
		// Always select the default train origin when switching to a train package tab
		store.dispatch("selectDefaultTrainOrigin", { overwrite: true, forceTrainPackCode: true })
	}
	const changedTransportType: boolean = hasChangedTransportType(store.state.packCode, packObj.codePackage, store.state.transportationSelected)

	if (packCode.value === packObj.codePackage) {
		store.dispatch("setPackagesMobileDropdownOpen", false)
		return
	}

	// First update package composition if needed
	if (packObj.codePackage !== "HS" && !isCS(packObj)) {
		await getPackageComposition(store)
	}

	// Then update the package
	await store.dispatch("setPackage", packObj.codePackage)
	store.state.packageId = packObj.packageId

}


const promos = computed(() => {
	const promoObject: Record<string, number> = {}
	if (Array.isArray(availablePackCodes.value)) {
		availablePackCodes.value.forEach((packObj) => {
			promoObject[packObj.codePackage] =
				maxPromosFromAvailablePackages.value[packObj.codePackage]
		})
	}
	return promoObject
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(content.value.flight_select_pack), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packagesToDisplay), (packObj) => {
        return (_openBlock(), _createElementBlock("div", {
          key: packObj.codePackage,
          onClick: ($event: any) => (handlePackageChange(packObj)),
          class: _normalizeClass(["package-tab d-flex align-items-center justify-content-between p-3 col", packCode.value === packObj.codePackage ? 'active' : 'text-grey-900'
					])
        }, [
          _createElementVNode("span", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPackageCompositionConfig(
						packObj.codePackage
					), (component, componentIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${packObj.codePackage}-${componentIndex}`
              }, [
                (componentIndex > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "+"))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_7, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                    _createElementVNode("use", {
                      "xlink:href": `#___icon___${component.icon}`
                    }, null, 8, _hoisted_9)
                  ])),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(getContentKey(component)), 1)
                ])
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            (
						packObj.codePackage !== 'HS' &&
						promos.value[packObj.codePackage] &&
						promos.value[packObj.codePackage] >= 5
					)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, " -" + _toDisplayString(promos.value[packObj.codePackage]) + "% ", 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})